import img1 from "../../../assets/images/IMG_9079-vision.JPG";
import img3 from "../../../assets/images/IMG_9093-min.JPG";
import img5 from "../../../assets/images/IMG_9112-min.JPG";
import img2 from "../../../assets/images/IMG_9161-min.JPG";
import img4 from "../../../assets/images/IMG_9209-min.JPG";

export const Activities = [
  { id: 1, Avatar: img1 },
  { id: 2, Avatar: img2 },
  { id: 3, Avatar: img3 },
  { id: 4, Avatar: img4 },
  { id: 5, Avatar: img5 },
];
